<template>
  <basic-modal
      source="cleanGateway"
      modal-title="Clean Gateway"
      @close="closeModal"
  >
  <!-- Turns out the Serial Number is actually the Device ID (sometimes also called the Device Name in some instances) -->
    <p class="apg-modal-text">Are you sure you want to clean the gateway with device ID <strong>{{ serialNumber }}</strong>?</p>
    <div class="d-flex justify-content-end">
      <button class="btn btn-secondary me-2" @click="closeModal">No</button>
      <button class="btn btn-primary" @click="cleanGateway">Yes</button>
    </div>
  </basic-modal>
</template>

<script>
import { useStore } from 'vuex';
import { computed } from 'vue';
import BasicModal from './basic-modal.vue';

export default {
  name: 'CleanGatewayModal',
  components: { BasicModal },
  setup() {
    const store = useStore();

    const serialNumber = computed(() => {
      const attributes = store.state.apgList.List.gateway_attribute;
      if (attributes) {
        console.log("attributes:", attributes);
        const serialNumberAttribute = attributes.find(attr => attr.attribute_key === 'Device Name');
        return serialNumberAttribute ? serialNumberAttribute.attribute_value : 'N/A';
      }
      return 'N/A';
    });

    const closeModal = () => {
      store.commit('apgList/hideModal', { listType: 'cleanGateway' });
    };

    const cleanGateway = () => {
      store.dispatch('gateway/cleanGateway');
      closeModal();
    };

    return {
      serialNumber,
      closeModal,
      cleanGateway,
    };
  },
};
</script>
